/** Interface pre manazer faz v discipline */
export interface DisciplinePhaseManager {

  preparePhase(): void;
  startPhase(): void;
  finishPhase(): void;
  update(): void;
  handleInputs(e: MouseEvent | undefined): void;
  setFinishPhaseTween(duration?: number): void;

}

/** Disciplinove fazy */
export enum DisciplinePhases {

  preStart = 0,
  start = 1,
  running = 2,
  draw = 3,
  flying = 4,
  finish = 5,
  end = 6

}

/** Stavy pohybu v cieli */
export enum MovementInFinishPhases {

  before = 0,
  setThings = 1,
  nonLinearDecrease = 2,
  linearDecrease = 3,
  stay = 4

}
